import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['container', 'sentinel'];

  connect() {
    this.offset = 20;
    this.loading = false;
    this.hasMore = true;

    this.observer = new IntersectionObserver(entries => {
      if(entries[0].isIntersecting) {
        this.loadMore();
      }
    });

    this.observer.observe(this.sentinelTarget);
  }
  
  disconnect() {
    if (this.observer && this.sentinelTarget) {
      this.observer.unobserve(this.sentinelTarget);
    }
  }

  loadMore() {
    if (this.loading) return;
    this.loading = true;

    const {
      accountId,
      boardId,
      clientId,
      peopleId,
      sort,
      direction,
      taskStatus,
      view,
      query
    } = this.element.dataset;

    const clientIds = this.safeParseArray(clientId);
    const baseUrl = this.buildBaseUrl({ accountId, peopleId, view });

    const params = new URLSearchParams({
      ...(sort && { sort: sort }),
      ...(direction && { direction: direction }),
      ...(taskStatus && { status: taskStatus }),
      ...(query && { q: query }),
      ...(view === 'everything_tasks' && boardId && { board_id: boardId }),
      offset: this.offset
    });
    clientIds.forEach(id => params.append("client_id[]", id));

    const fullUrl = `${baseUrl}?${params.toString()}`;
    let body = document.querySelector('body');
    let flashMessage = document.querySelector('.flash-message');
    if (flashMessage) {
      flashMessage.addClass('.sticky-flash');
      flashMessage.innerHTML = "Loading tasks ... please wait !!";
    } else {
      body.insertAdjacentHTML("afterbegin", "<div class=\"flash-message sticky-flash notice\">Loading tasks ... please wait !!</div>");
      flashMessage = document.querySelector('.flash-message');
    }

    fetch(fullUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(res => res.json())
      .then(data => this.handleLoadMoreResponse(data, flashMessage))
      .catch(error => console.error("Error loading more tasks: ", error))
      .finally(() => {
        this.loading = false;
      })
  }


  buildBaseUrl({ accountId, peopleId, view }) {
    switch(view) {
      case 'account_member':
        return `/${accountId}/people/${peopleId}/load_more_tasks`;
      case 'everything_tasks':
        return `/${accountId}/boards/all/load_more_tasks`;
      default:
        console.warn('Unknown view: ', view);
        return;
    }
  }

  handleLoadMoreResponse(data, flashMessage) {
    this.containerTarget.insertAdjacentHTML("beforeend", data.html);
    if (!data.more_projects) {
      this.hasMore = false;
      this.observer.unobserve(this.sentinelTarget);
    }

    this.offset += 20;
    flashMessage.remove();
  }

  safeParseArray(value) {
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}